import menuItemsHost from './menu-items-host'

const menuItemsPro = [
  {
    text: 'Dashboard',
    description: 'System overview and key metrics',
    icon: 'mdi-view-dashboard',
    value: '/dashboard/system',
    allowed_roles: ['admin'],
  },
  {
    text: 'Multi calendar',
    description: 'View availability across all properties',
    allowed_roles: [
      'admin',
      'communication-manager',
      'communication-agent',
      'sales-manager',
      'sales-agent',
      'cleaning-supervisor',
      'cleaning-manager',
      'cleaner',
      'property-manager',
      'coordinator',
      'field-pm',
      'investor',
    ],
    icon: 'mdi-calendar-multiselect',
    value: '/dashboard/multi-calendar',
    tabs: ['Calendar', 'Blocks', 'Availability'],
  },
  {
    text: 'CRM',
    description: 'Customer relationship management and guest experience',
    allowed_roles: [
      'admin',
      'communication-manager',
      'communication-agent',
      'sales-manager',
      'sales-agent',
      'property-manager',
      'coordinator',
    ],
    module: 'comm',
    abilities: ['crm-management'],
    abilityOrRole: true,
    icon: 'mdi-account-outline',
    value: '/dashboard/guest-experience',
  },
  {
    text: 'Owners',
    description: 'Property owner and investor management',
    icon: '$owner',
    submenu: [
      {
        text: 'Listings',
        description: 'Manage property listings and details',
        value: '/dashboard/listings',
        allowed_roles: [
          'admin',
          'investor',
          'property-manager',
          'coordinator',
          'accountant',
          'field-pm',
        ],
        icon: 'mdi-home-variant-outline',
        demo_only: true,
      },
      {
        text: 'Portfolio',
        description: 'Investment portfolio analysis and performance',
        icon: 'mdi-briefcase-outline',
        value: '/dashboard/portfolio',
        module: 'ops',
        allowed_roles: ['admin', 'investor', 'property-manager', 'field-pm'],
        tabs: ['Portfolio', 'Reviews'],
      },
    ],
  },
  {
    text: 'Operations',
    description: 'Daily operations and task management',
    icon: '$operations',
    submenu: [
      {
        text: 'Field Ops',
        description: 'Field operations and service call management',
        allowed_roles: [
          'admin',
          'communication-manager',
          'communication-agent',
          'sales-manager',
          'sales-agent',
          'cleaning-supervisor',
          'cleaning-manager',
          'property-manager',
          'coordinator',
          'hotel-reception',
          'accountant',
          'contractor',
          'cleaner',
          'field-pm',
          'pools-manager',
          'repairs-manager',
          'landscaping-manager',
        ],
        module: 'ops',
        icon: 'mdi-account-hard-hat-outline',
        value: '/dashboard/service-calls',
        demo_only: true,
        tabs: ['Area Report', 'My Tasks', 'Calendar', 'PM Summary'],
      },
      {
        text: 'Office Tasks',
        description: 'Administrative tasks and workflow management',
        icon: 'mdi-office-building-cog-outline',
        value: '/dashboard/taskim',
        allowed_roles: [
          'admin',
          'communication-manager',
          'communication-agent',
          'sales-agent',
          'sales-manager',
          'property-manager',
          'coordinator',
          'accountant',
        ],
        module: 'ops',
      },
      {
        text: 'IoT',
        description: 'Internet of Things device management',
        abilities: ['iot-management'],
        module: 'iot',
        icon: 'mdi-router-wireless',
        value: '/dashboard/iot',
      },
      {
        text: 'Damage Protection',
        allowed_roles: ['admin', 'property-manager', 'coordinator'],
        module: 'ops',
        icon: 'mdi-shield-check',
        value: '/dashboard/damage-protection',
      },
      {
        text: 'Storage',
        description: 'Inventory and storage management',
        allowed_roles: [
          'admin',
          'cleaning-manager',
          'cleaning-supervisor',
          'property-manager',
          'coordinator',
          'accountant',
          'field-pm',
        ],
        isPrivate: true,
        icon: 'mdi-warehouse',
        module: 'projects',
        value: '/dashboard/inventory',
      },
      {
        text: 'Projects',
        description: 'Property setup and development projects',
        allowed_roles: ['admin', 'property-manager', 'coordinator', 'field-pm'],
        isPrivate: true,
        icon: 'mdi-briefcase-check-outline',
        abilities: ['projects'],
        module: 'projects',
        value: '/dashboard/listings-setup',
      },
      {
        text: 'Processes',
        description: 'Workflow and process templates',
        allowed_roles: ['admin', 'property-manager', 'coordinator', 'field-pm'],
        icon: 'mdi-sitemap-outline',
        value: '/dashboard/processes',
      },
      {
        text: 'Automated Tasks',
        description: 'Configure automated rules and triggers',
        allowed_roles: ['admin', 'property-manager'],
        abilities: ['auto-rules-manager'],
        icon: 'mdi-robot',
        value: '/dashboard/auto-tasks',
      },
      {
        text: 'Ops Settings',
        description: 'Operations configuration and settings',
        icon: 'mdi-cog-outline',
        value: '/dashboard/operations-settings',
        allowed_roles: ['admin', 'property-manager', 'coordinator'],
        module: 'ops',
        tabs: ['Task Catalog', 'Info Definitions'],
      },
    ],
  },
  {
    text: 'Guests',
    description: 'Guest management and communication',
    icon: '$guest_fill',
    submenu: [
      {
        text: 'Experience',
        description: 'Guest experience management and CRM',
        allowed_roles: [
          'admin',
          'communication-manager',
          'communication-agent',
          'sales-manager',
          'sales-agent',
          'property-manager',
          'coordinator',
          'field-pm',
        ],
        module: 'guest-exp',
        icon: 'mdi-emoticon-outline',
        value: '/dashboard/guest-mgmt',
        tabs: [
          'Check-in/out',
          'Purchases',
          'Requests',
          'Checkin & store settings',
        ],
      },
      {
        text: 'Guest Book',
        description: 'Digital guest registration and information',
        icon: 'mdi-book-open-outline',
        value: '/dashboard/guest-book',
        allowed_roles: ['admin'],
        module: 'ops',
      },
      {
        text: 'Automated Messages',
        description: 'Configure automated guest communications',
        allowed_roles: [
          'admin',
          'communication-manager',
          'communication-agent',
          'sales-manager',
          'sales-agent',
          'property-manager',
          'coordinator',
        ],
        icon: 'mdi-robot',
        value: '/dashboard/auto-messages',
        tabs: ['Guests', 'Users', 'WA templates'],
      },
    ],
  },
  {
    text: 'Marketing',
    description: 'Marketing tools and channel management',
    icon: '$marketing',
    submenu: [
      {
        text: 'Channels',
        description: 'Channel manager and distribution platforms',
        allowed_roles: ['admin'],
        icon: 'mdi-access-point-network',
        value: '/dashboard/cm',
        module: 'channel-manager',
        tabs: ['Listings', 'Channels', 'Charge Profiles', 'Rate Plans'],
      },
      {
        text: 'Reviews',
        description: 'Guest reviews and reputation management',
        allowed_roles: [
          'admin',
          'communication-manager',
          'communication-agent',
          'sales-manager',
          'sales-agent',
          'property-manager',
          'coordinator',
        ],
        module: 'comm',
        icon: 'mdi-star-outline',
        value: '/dashboard/reviews-dashboard',
        tabs: [
          'Received Reviews',
          'Pending Reviews',
          'Channel links',
          'Listing logs',
        ],
      },
      {
        text: 'Pricing',
        description: 'Dynamic pricing and revenue optimization',
        icon: 'mdi-currency-usd',
        value: '/dashboard/pricing-panel',
        allowed_roles: ['admin'],
        abilities: ['pricing-manager'],
        module: 'pricing',
        tabs: [
          'Pricing',
          'Pricing Strategies',
          'Settings',
          'LOS',
          'Rate Imports',
        ],
      },
      {
        text: 'Agents',
        description: 'Sales agent performance and reservations',
        icon: 'mdi-account-tie',
        value: '/dashboard/agent-reservations',
        allowed_roles: ['admin', 'agent', 'sales-agent', 'sales-manager'],
        module: 'ops',
      },
      {
        text: 'Websites',
        description: 'Website builder and direct booking sites',
        icon: 'mdi-web',
        value: '/dashboard/websites',
        allowed_roles: ['admin'],
      },
    ],
  },
  {
    text: 'Accounting',
    description: 'Financial management and accounting',
    icon: '$accounting_fill',
    submenu: [
      {
        text: 'Payables',
        description: 'Accounts payable and expense management',
        icon: 'mdi-cash-register',
        value: '/dashboard/payables',
        module: 'accounting',
        allowed_roles: ['admin', 'accountant', 'property-manager'],
        tabs: [
          'Contractors Payments',
          'Owners Payments',
          'Management Payments',
          'Taxes Payments',
          'Transfers',
          'Reservation Balance',
        ],
      },
      {
        text: 'Bank Feeds',
        description: 'Bank transaction feeds and reconciliation',
        icon: 'mdi-bank',
        value: '/dashboard/bank-feeds',
        module: 'accounting',
        allowed_roles: ['admin', 'accountant', 'property-manager'],
        tabs: ['Bank Transactions', 'Bank Accounts'],
      },
      {
        text: 'Ledger',
        description: 'General ledger and chart of accounts',
        icon: 'mdi-book-open-variant',
        value: '/dashboard/ledger-wallet',
        module: 'accounting',
        allowed_roles: ['admin', 'accountant'],
        tabs: ['Trust Account', 'Operations Account', 'Account lines'],
      },
      {
        text: 'Financials',
        description: 'Financial reports and analysis',
        icon: 'mdi-cash-multiple',
        value: '/dashboard/financials',
        module: 'accounting',
        allowed_roles: [
          'admin',
          'accountant',
          'property-manager',
          'coordinator',
        ],
        tabs: [
          'Expenses',
          'Reservations',
          'Payments',
          'Expense types',
          'Business model',
        ],
      },
      {
        text: 'Invoices',
        description: 'Invoice generation and management',
        icon: 'mdi-file-document-outline',
        value: '/dashboard/invoices',
        allowed_roles: ['admin'],
      },
    ],
  },
  {
    text: 'Configuration',
    description: 'System configuration and settings',
    icon: '$configuration',
    submenu: [
      {
        text: 'Settings',
        description: 'General system settings and user management',
        allowed_roles: [
          'admin',
          'property-manager',
          'coordinator',
          'communication-manager',
          'communication-agent',
          'sales-agent',
          'sales-manager',
        ],
        demo_only: true,
        abilities: [
          'estimates-config',
          'users-management',
          'real-estate-finance',
          'pricing-manager',
          'channel-management',
        ],
        icon: '$settings_fill',
        value: '/dashboard/management',
        tabs: [
          'Users',
          'Settings',
          'Real Estate',
          'Regions',
          'Zones',
          'Coupon Settings',
          'Coupons',
          'Estimates',
        ],
      },
      {
        text: 'AI',
        description: 'Artificial intelligence configuration and policies',
        allowed_roles: ['admin'],
        abilities: ['ai-config'],
        module: 'ai',
        icon: '$ai',
        value: '/dashboard/ai-config',
      },
    ],
  },
  {
    text: 'Feeds',
    description: 'Data feeds and integrations',
    icon: 'mdi-pound',
    value: '/dashboard/feeds',
    allowed_roles: ['admin'],
    module: 'ops',
  },
  {
    text: 'Analytics',
    description: 'Business intelligence and performance analytics',
    isPrivate: true,
    allowed_roles: [
      'admin',
      'field-pm',
      'property-manager',
      'coordinator',
      'hotel-reception',
      'communication-manager',
      'sales-manager',
    ],
    demo_only: true,
    icon: 'mdi-chart-line',
    abilities: [
      'bi-reviews',
      'bi-cleaning',
      'bi-revenue',
      'bi-accounting',
      'bi-comm',
      'bi-pm',
      'bi-invest',
      'bi-inventory',
    ],
    module: 'bi',
    value: '/dashboard/performance',
  },
  {
    text: 'Dev Tools',
    description: 'Developer tools and system diagnostics',
    allowed_roles: ['admin'],
    abilities: ['super-admin', 'view-logs'],
    icon: 'mdi-tools',
    value: '/dashboard/dev-tools',
  },
]

const getMenuItems = productType => {
  switch (productType) {
    case 'boom-host':
      return menuItemsHost
    default:
      return menuItemsPro
  }
}

export { menuItemsPro, menuItemsHost, getMenuItems }
export default menuItemsPro

/*
  menu-items.js

  2025-05-29: Added description fields to all menu items for enhanced search functionality
  2025-05-23: Added 'Processes' menu item under Operations section for process management roles, linking to listing-task-templates page
  2024-05-24: Added 'Websites' menu item under Marketing section for admin role, linking to website builder page
*/
